

var Ably = require('ably');
var configurationManager = require('../../config/configurationManager.js');
var commonUtility = require('../../domain/commonUtility.js');
var terminalUtility = require('../../domain/terminalUtility.js');
var messagingUtil = require('../messagingUtil.js');
var notificationChannelMessageHandler = require('./notificationChannelMessageHandler.js');

const logger = require('../../logger/logger.js');

var messagingConnection;
var messagingChannel;
var channelSubscribed = false;

module.exports.getChannelName = function(property)
{
    return `property.${property.id}.notification`;
}

module.exports.establishConnection = function()
{
    unSubscribeChannel();
    closeExistingConnection();

    return new Promise ((resolve, reject) =>
    {
        try
        {
            var property = commonUtility.getProperty();

            var connectionOptions = {};
            connectionOptions.key = configurationManager.getConfig().messagingPlatformApiKey;
            connectionOptions.clientId = terminalUtility.getTerminalCode();
            messagingConnection = new Ably.Realtime(connectionOptions);

            var self = this;
            messagingConnection.connection.on('connected', function() 
            {
                try
                {
                    if (!channelSubscribed)
                    {
                        channelSubscribed = true;

                        messagingConnection.connection.off();       //Unsubscribe from all connection related events.
                        messagingConnection.connection.on('connected', self.onConnected);

                        messagingConnection.connection.on('disconnected', self.onDisconnected);
                        messagingConnection.connection.on('suspended', self.onSuspended);
                        messagingConnection.connection.on('failed', self.onFailed);
                        
                        messagingChannel = messagingConnection.channels.get(self.getChannelName(property));
                        messagingChannel.subscribe(self.onMessage);
                    }
                }
                catch(error)
                {
                    logger.error("Error occurred on connected call back of notification channel " + error, {}, error);
                }
            });

            resolve('connected');
        }
        catch(error)
        {
            reject(error);
        }

    });
}

function closeExistingConnection()
{
    if (messagingConnection == null)
        return;

    try
    {
        messagingConnection.close();
    }
    catch(error)
    {   
        logger.error(`Error occurred while closing connection. ${error}`, null, error);
    }
}

function unSubscribeChannel()
{
    if (messagingChannel == null)
        return;

    try
    {
        messagingChannel.unsubscribe(module.exports.onMessage);
    }
    catch(error)
    {   
        logger.error(`Error occurred while unsubscribe channel. ${error}`, null, error);
    }

    messagingChannel = null;
    channelSubscribed = false;
}

module.exports.onConnected = function()
{
    logger.info("Notification Channel state changed to connected.");

    /* This state is only maintained and changed by sales channel
    if (stateManager.getStore().getState().internetConnectionSuspended)
    {
        stateManager.getStore().dispatch(internetConnectionSuspendedAction.createAction(false));
    }

    if (stateManager.getStore().getState().internetConnectionDisconnected)
    {
        stateManager.getStore().dispatch(internetConnectionDisconnectedAction.createAction(false));
    }
    */
}

/*

A temporary failure condition when no current connection exists.The disconnected state is entered if an 
established connection is dropped, or if a connection attempt is unsuccessful. In the disconnected state an 
SDK will periodically attempt to open a new connection (approximately every 15 seconds), 
anticipating the connection will be re-established soon and connection and channel continuity will be possible. 
In this state, developers can continue to publish messages as they are automatically placed in a local queue, 
sent when connection is re-established. Messages published by other clients whilst this client is disconnected 
will be delivered to it when reconnected if the connection was resumed within two minutes. After two minutes 
have elapsed, recovery is no longer possible and the connection will move to the suspended state.
*/
module.exports.onDisconnected = function()
{
    logger.warn("Notification Channel state changed to disconnected.");

    /* This state is only maintained and changed by sales channel
    if (!stateManager.getStore().getState().internetConnectionDisconnected)
    {
        stateManager.getStore().getState().internetConnectionSuspended = false;
        stateManager.getStore().dispatch(internetConnectionDisconnectedAction.createAction(true));
    }*/
}

/*
A long term failure condition when no current connection exists because there is no network connectivity or 
available host.The suspended state is entered after a failed connection attempt if there has then been no 
connection for a period of two minutes. In the suspended state, an SDK will periodically attempt to open a new 
connection every 30 seconds. Developers are unable to publish messages in this state. A new connection attempt 
can also be triggered by an explicit call to connect() on the Connection object.Once the connection has been 
re-established, channels will be automatically re-attached. The client has been disconnected for too long for them 
to resume from where they left off, so if it wants to catch up on messages published by other clients while 
it was disconnected, it needs to use the history API.
*/
module.exports.onSuspended = function()
{
    logger.warn("Notification Channel state changed to suspended.");

    /* This state is only maintained and changed by sales channel
    if (!stateManager.getStore().getState().internetConnectionSuspended)
    {
        stateManager.getStore().getState().internetConnectionDisconnected = false;
        stateManager.getStore().dispatch(internetConnectionSuspendedAction.createAction(true));
    }
    */
}

/*
This state is entered if an SDK encounters a failure condition that it cannot recover from. This may be a 
fatal connection error received from the Ably service (e.g. an attempt to connect with an incorrect API key), or 
some local terminal error (e.g. the token in use has expired and the SDK does not have any way to renew it).
In the failed state, no reconnection attempts are made automatically by an SDK, and clients may not publish messages. 
A new connection attempt can be triggered by an explicit call to connect() on the Connection object.
*/
module.exports.onFailed = function()
{
    logger.error("Notification Channel state changed to failed.");

    /* This state is only maintained and changed by sales channel
    if (!stateManager.getStore().getState().internetConnectionSuspended)
    {
        stateManager.getStore().getState().internetConnectionDisconnected = false;
        stateManager.getStore().dispatch(internetConnectionSuspendedAction.createAction(true));
    }
    */
}



module.exports.onMessage = function(message)
{
    try
    {
        if (message == null || message.data == null)
        {
            logger.info("Empty / null message received from sales channel.");
            return;
        }

        if (messagingUtil.isMessageAlreadyHandled(message.id))
        {
            logger.warn(`Duplicate Sales channel Message with id ${message.id} found.`);
            return;
        }
        
        logger.info("Message received via ably sales channel");
        var payload = JSON.parse(message.data);
        notificationChannelMessageHandler.onMessage(payload);
    }
    catch(error)
    {
        logger.error(`Following error occurred on sales channel message. ${error}`, {}, error);
    }
}
